export default function setCookie(cname, cvalue) {
  document.cookie = `${cname}=${cvalue};`
}
